var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorneDIstanceA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2026 192.165V180.965L56.1227 204.505V218.075L12.2026 192.165Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5126 205.775L12.2026 180.975L179.633 81.8447L219.743 101.675L56.5126 205.775Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9927 218.395V205.135L219.753 101.565V112.995L55.9927 218.395Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8228 171.735L22.4329 174.905L50.1328 190.175L55.7628 186.645L27.8228 171.735Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0028 155.045L50.6128 158.225L78.3028 173.515L83.9328 169.985L56.0028 155.045Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3227 163.745L36.7327 166.475L54.8727 175.495L59.7527 172.385L41.3227 163.745Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3827 137.655L80.0027 140.855L107.773 156.005L113.383 152.445L85.3827 137.655Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.883 121.305L107.523 124.535L135.383 139.525L140.973 135.935L112.883 121.305Z",
    fill: "#FECECA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0827 130.155L93.4827 132.865L111.583 141.985L116.473 138.895L98.0827 130.155Z",
    fill: "#FECECA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M140.543 104.995L135.143 108.165L162.823 123.475L168.453 119.955L140.533 104.995H140.543Z",
    fill: "#FECECA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M168.643 88.3547L163.263 91.5447L191.013 106.725L196.623 103.175L168.633 88.3547H168.643Z",
    fill: "#FECECA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.633 97.2446L149.033 99.9646L167.163 109.025L172.043 105.925L153.633 97.2446Z",
    fill: "#FECECA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.263 113.415L121.653 116.115L139.733 125.265L144.633 122.195L126.263 113.415Z",
    fill: "#FECECA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2128 147.205L64.6328 149.965L82.8228 158.885L87.6828 155.745L69.2028 147.205H69.2128Z",
    fill: "#F97E73"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.713 44.2346C113.713 50.8046 116.713 55.9846 123.863 55.9846C131.013 55.9846 133.993 50.8046 133.993 44.2346C133.993 38.1046 131.283 32.1348 123.863 32.1348C116.443 32.1348 113.713 37.6446 113.713 44.2346ZM119.253 44.0447C119.253 40.5847 120.463 37.0046 123.863 37.0046C127.263 37.0046 128.453 40.3247 128.453 44.0447C128.453 47.4947 127.263 51.1248 123.863 51.1248C120.463 51.1248 119.253 47.7647 119.253 44.0447Z",
    fill: "#F97E73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.003 44.2546H136.563V48.4146H149.003V44.2546Z",
    fill: "#F97E73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.903 55.6545H160.513V32.4846H149.463V37.3147H154.903V55.6545Z",
    fill: "#F97E73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.663 44.2346C163.663 50.8046 166.663 55.9846 173.813 55.9846C180.963 55.9846 183.943 50.8046 183.943 44.2346C183.943 38.1046 181.233 32.1348 173.813 32.1348C166.393 32.1348 163.663 37.6446 163.663 44.2346ZM169.203 44.0447C169.203 40.5847 170.413 37.0046 173.813 37.0046C177.213 37.0046 178.403 40.3247 178.403 44.0447C178.403 47.4947 177.213 51.1248 173.813 51.1248C170.413 51.1248 169.203 47.7647 169.203 44.0447Z",
    fill: "#F97E73"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.333 55.6545H213.703V45.0146C213.703 41.0146 210.723 38.9346 207.563 38.9346C205.503 38.9346 203.383 39.7946 202.053 41.6646C201.183 39.8546 199.083 38.9346 196.903 38.9346C194.973 38.9346 192.993 39.5346 191.833 41.0046L191.663 39.2747H186.733V55.6545H192.103V46.5447C192.103 44.7247 193.483 43.8547 194.833 43.8547C196.183 43.8547 197.513 44.7247 197.513 46.5447V55.6545H202.883V46.5447C202.883 44.7247 204.303 43.8547 205.643 43.8547C206.983 43.8547 208.323 44.7247 208.323 46.5447V55.6545H208.333Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorneDIstanceA);
export default __webpack_public_path__ + "static/media/borneDIstanceA.33c227e508269c1bc0d3c7caf7578f7a.svg";
export { ForwardRef as ReactComponent };